import gql from "graphql-tag";

export const GET_STUDENT_PROFILE = gql`
    query getUserProfile($id: Int) {
        student_profile(where: { user_id: { _eq: $id } }) {
            id
            user_id
            highschool_info
            financial_aid_settings
            immigration_details
            product_type
            is_trial
            graduation_year
            user {
                guardians: student_guardians {
                    guardian {
                        user_email
                        user_first_name
                        user_last_name
                    }
                }
            }
        }
    }
`;

export const UPDATE_STUDENT_PROFILE = gql`
    mutation update($id: Int, $input: student_profile_set_input) {
        update_student_profile(where: { user_id: { _eq: $id } }, _set: $input) {
            returning {
                id
                user_id
                financial_aid_settings
            }
        }
    }
`;
